import React from 'react';

class Header extends React.Component {
  render() {
    
    return (
        <div >
          <h1 id="main-title">Gather</h1>
          <hr id="title-underline"/>
        </div>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js